import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';
import { PayloadStates } from '@lore/utils';
import { useState } from 'react';
import getOfferBucketParams from '../my-offers/getBucketParams';

export default function useActiveOpportunityCount() {
  const currentUser = useUser();

  const [timestamp] = useState(new Date().toISOString());

  const offerParams = getOfferBucketParams(timestamp);

  const projects = useConnect('project.find', {
    where: {
      filter: { active: true, creatorId: currentUser.id }
    },
    pagination: {
      pageSize: 0,
      order: 'createdAt desc'
    }
  });

  const events = useConnect('event.find', {
    where: {
      filter: { active: true, creatorId: currentUser.id }
    },
    pagination: {
      pageSize: 0,
      order: 'createdAt desc'
    }
  });

  const offers = useConnect('offer.find', {
    where: {
      eager: {
        $where: {
          creatorId: currentUser.id,
          activityId: {
            $null: false
          },
          // createdAt: {
          //   $lte: timestamp
          // },
          ...offerParams.active
        }
      }
    },
    pagination: {
      pageSize: 1,
      order: 'createdAt desc'
    }
  });

  if (
    projects.state === PayloadStates.FETCHING ||
    events.state === PayloadStates.FETCHING ||
    offers.state === PayloadStates.FETCHING
  ) {
    return '...';
  }

  const grandTotal = projects.meta?.totalCount + events.meta?.totalCount + offers.meta?.totalCount;
  if (grandTotal === 0) {
    return null;
  }

  return grandTotal;
}
